import { render, staticRenderFns } from "./BaseConfigMana.vue?vue&type=template&id=79b44928&scoped=true&"
import script from "./BaseConfigMana.vue?vue&type=script&lang=js&"
export * from "./BaseConfigMana.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfigMana.vue?vue&type=style&index=0&id=79b44928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b44928",
  null
  
)

export default component.exports